import { useState, type ReactNode } from 'react'
import { TopHeader } from './TopHeader'
import { Sidebar } from './Sidebar'
import type { ViewId } from '@/types/navigation'
import type { ConnectionStatus } from '@/types/chat'
import styles from './AppShell.module.css'

interface AppShellProps {
  activeView: ViewId
  onNavigate: (id: ViewId) => void
  connectionStatus: ConnectionStatus
  children: ReactNode
}

export function AppShell({ activeView, onNavigate, connectionStatus, children }: AppShellProps) {
  const [mobileNavOpen, setMobileNavOpen] = useState(false)

  return (
    <div className={styles.root}>
      <TopHeader
        connectionStatus={connectionStatus}
        onToggleMobileNav={() => setMobileNavOpen((open) => !open)}
      />
      <div className={styles.body}>
        <Sidebar
          activeView={activeView}
          onSelect={onNavigate}
          mobileOpen={mobileNavOpen}
          onCloseMobile={() => setMobileNavOpen(false)}
        />
        <main className={styles.main}>{children}</main>
      </div>
    </div>
  )
}
